import Image from 'next/image';
import React, { FC } from 'react';

import {
  FeaturedBrandsWrapper,
  FeaturedBrandsHeader,
  FeaturedBrandsInfo,
  ImageContainer,
} from './style';

type PropsType = {
  data: {
    title: string;
    brands: { data: IMediaICon[] };
  };
};

interface IMediaICon {
  attributes: { url: string; width: number; height: number };
}

export const FeaturedBrands: FC<PropsType> = ({ data }) => {
  if (!data) {
    return null;
  }

  const { title, brands } = data;

  const servicesElements = brands?.data?.map((item, index) => {
    const image = item.attributes.url;
    return (
      <ImageContainer key={`brand-item-${index}`}>
        <Image
          src={image}
          width={item.attributes.width}
          height={item.attributes.height}
          alt="brand-image"
        />
      </ImageContainer>
    );
  });

  return (
    <FeaturedBrandsWrapper>
      <FeaturedBrandsHeader text={title} />
      <FeaturedBrandsInfo>{servicesElements}</FeaturedBrandsInfo>
    </FeaturedBrandsWrapper>
  );
};
